import { create } from "zustand";

const useMarketingStore = create((set) => ({
    showCTATextArea: false,
    hideCustomPrompt: false,
    ctaResponseReceived: false, 
    
    setShowCTATextArea: (value) => set({ showCTATextArea: value }),
    setHideCustomPrompt: (value) => set({ hideCustomPrompt: value }),
    setCtaResponseReceived: (value) => set({ ctaResponseReceived: value }),
    resetCtaResponse: () => set({ ctaResponseReceived: false }), 

}));

export default useMarketingStore;
